import SchemePopupLayout from "./SchemePopupLayout";

const EducationLoanSchemePopup = ({ onClose }) => {
  return (
    <SchemePopupLayout
      title="Education Loan Scheme"
      intro="The Education Loan Scheme helps eligible students from minority communities pursue professional, technical, and higher education by offering financial assistance for course fees and related academic expenses."
      eligibility={[
        "Applicant must belong to a notified minority community.",
        "Admission should be secured in an eligible course or institution.",
        "Annual family income should fall within NMDFC income limits.",
        "Applicant must meet age and academic criteria prescribed for the scheme.",
      ]}
      documents={[
        "Aadhaar Card / Identity Proof",
        "Address Proof",
        "Admission Letter",
        "Course Fee Structure",
        "Income Certificate",
        "Minority Community Certificate",
        "Academic Records",
        "Bank Account Details",
      ]}
      applyLabel="Apply for Education Loan"
      videoUrl="https://www.youtube.com/embed/3WrOnzIMx9o"
      onClose={onClose}
    />
  );
};

export default EducationLoanSchemePopup;
